import React,  { useState } from 'react';
import Alert from 'react-bootstrap/Alert'
import {Button} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import SiteAdd from './SiteAdd'

export default function SiteGuideRender(props) {

  return (
    PageWrapper (props,
      <Alert className='alert-fadein below-nav' variant='primary' >
        <h4 className="alert-heading"><FontAwesomeIcon icon={faMinusCircle} color='pink'/>&nbsp;
        Welcome to the Web App</h4>
        This is normally the page where you get a list of all your sites. But you do not have
        permission to view any sites. Try using the Add Site button or ask someone for help.
      </Alert>
    )
  )
};
export function SiteFailRender (props) {
  return PageWrapper (props, SiteFail())
}
export function SiteFail() {
  return (
   <Alert className='alert-fadein below-nav' variant='primary' >
      <h4 className="alert-heading"><FontAwesomeIcon icon={faMinusCircle} color='pink'/>&nbsp;
      Well, that didn't work</h4>
      This is the page where you usually get a list of all your sites. But something's gone
      wrong. We could not get any sites. You might need to log out and then back in again.
    </Alert>
  )
}
function PageWrapper(props, child) {
  const [show, showToggle] = useState(false);
  return (
  <div className='content-container'>
    <SiteAdd {...props} show={show} hide={()=>showToggle(false)} />
    <div className="left-hand-pane">
      <img src="tehama_logo_100p.png" className="nav-logo" onClick={() => {window.location.href='/';}} alt="Tehama Logo"></img>
      <div className="title-vert-spacer">
        <span className="list-title">Site List</span>
        <Button className="site-add-button" onClick={()=>showToggle(true)}>
          +&nbsp;&nbsp;Add Site
        </Button>
      </div>
    </div>
    {child}
  </div>
  )
} 